import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@ibc-features/user/services/auth.service';
import { CookiesComponent } from '@ibc-shared/components/cookies/cookies.component';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { LanguageService } from './shared/services/language.service';

@Component({
  selector: 'app-root',
  imports: [TranslateModule, RouterOutlet, HeaderComponent, FooterComponent, CookiesComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private languageService: LanguageService = inject(LanguageService);
  private authService = inject(AuthService);

  constructor() {
    this.languageService.initLanguage();
    this.authService.checkAuth().subscribe();
  }
}
